/* eslint-disable react/jsx-pascal-case */
import { useEffect } from 'react'
import { useDispatch } from 'store'
import T_FormOnly from 'components/4_Templates/T_FormOnly'
import O_SearchBoxCreatePassword from 'components/3_Organisms/Groups/O_SearchBoxCreatePassword'
import * as LoginAction from 'slicers/LoginSlice'

const P_CreatePassword = ({ title }: { title: string }) => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(LoginAction.format())
  }, [])

  return (
    <T_FormOnly>
      <O_SearchBoxCreatePassword title={title} />
    </T_FormOnly>
  )
}
export default P_CreatePassword
